import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { usePerson, useUpdatePerson } from '../../api/pool';
import StatusBadge from '../../components/StatusBadge';

export default function PersonDetail() {
  const { id } = useParams();
  const { data: p, isLoading, error } = usePerson(id);
  const update = useUpdatePerson(id!);
  const [editing, setEditing] = useState(false);
  const [comp, setComp] = useState('');
  const [phone, setPhone] = useState('');
  const [err, setErr] = useState<string | null>(null);

  if (isLoading) return <p className="muted">Loading…</p>;
  if (error) return <p className="error">Could not load candidate: {String(error)}</p>;
  if (!p) return null;

  const startEdit = () => { setComp(p.compensation ?? ''); setPhone(p.phone ?? ''); setEditing(true); setErr(null); };
  const save = () => {
    setErr(null);
    update.mutate(
      { compensation: comp.trim() || null, phone: phone.trim() || null },
      { onSuccess: () => setEditing(false), onError: (e) => setErr(e instanceof Error ? e.message : 'Failed') },
    );
  };

  return (
    <div className="panel">
      <div className="panel-head">
        <div>
          <Link to="/candidates" className="muted small">← All candidates</Link>
          <h2 style={{ marginTop: '0.4rem' }}>{p.fullName}</h2>
        </div>
        {!editing && <button className="btn-ghost" onClick={startEdit}>Edit</button>}
      </div>

      {err && <div className="banner-error">{err}</div>}

      {editing ? (
        <div className="form" style={{ maxWidth: 480 }}>
          <label className="field"><span>Phone</span><input value={phone} onChange={(e) => setPhone(e.target.value)} /></label>
          <label className="field"><span>Compensation expectations</span><input value={comp} onChange={(e) => setComp(e.target.value)} /></label>
          <div className="form-actions">
            <button className="btn-primary" onClick={save} disabled={update.isPending}>Save</button>
            <button className="btn-ghost" onClick={() => setEditing(false)} disabled={update.isPending}>Cancel</button>
          </div>
        </div>
      ) : (
        <div className="meta-grid">
          <div><span className="meta-label">Email</span><span>{p.email}</span></div>
          <div><span className="meta-label">Phone</span><span>{p.phone ?? '—'}</span></div>
          <div><span className="meta-label">Compensation expectations</span><span>{p.compensation ?? '—'}</span></div>
        </div>
      )}

      <h3 style={{ marginTop: '1.5rem' }}>Applications</h3>
      {p.applications.length === 0 ? (
        <p className="muted">Not proposed to any job yet. Open a job and use "Propose candidate".</p>
      ) : (
        <table className="table">
          <thead><tr><th>Job</th><th>Status</th></tr></thead>
          <tbody>
            {p.applications.map((app) => (
              <tr key={app.id} className="row-link">
                <td><Link to={`/applications/${app.id}`}>{app.job.title}</Link></td>
                <td><StatusBadge status={app.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
